import React from 'react';

/* Renders <option>/<optgroup> elements for a brand-profile <select> so that
   sub-profiles are visually nested under their parent group (instead of a flat,
   jumbled list). Parent groups become <optgroup> labels; the parent itself stays
   selectable, and its sub-profiles are indented beneath it. Childless top-level
   profiles render as plain options. */
export function groupedProfileOptions(profiles) {
  if (!Array.isArray(profiles)) return null;
  const parents = profiles.filter((p) => !p.parent_id);
  const childrenByParent = {};
  profiles.forEach((p) => {
    if (p.parent_id) (childrenByParent[p.parent_id] = childrenByParent[p.parent_id] || []).push(p);
  });
  const knownIds = new Set(profiles.map((p) => p.profile_id));
  const out = [];
  parents.forEach((parent) => {
    const kids = childrenByParent[parent.profile_id] || [];
    if (kids.length) {
      out.push(
        <optgroup key={parent.profile_id} label={parent.name}>
          <option value={parent.profile_id}>{parent.name + ' (whole group)'}</option>
          {kids.map((k) => (
            <option key={k.profile_id} value={k.profile_id}>{'\u2003\u21B3 ' + k.name}</option>
          ))}
        </optgroup>
      );
    } else {
      out.push(<option key={parent.profile_id} value={parent.profile_id}>{parent.name}</option>);
    }
  });
  // Orphans whose parent isn't in the list — show them flat so nothing disappears.
  const orphans = profiles.filter((p) => p.parent_id && !knownIds.has(p.parent_id));
  orphans.forEach((o) => out.push(<option key={o.profile_id} value={o.profile_id}>{o.name}</option>));
  return out;
}
